import { z } from "zod";

export const getTerminalPairingUpdatesParamSchema = z.object({
	deviceId: z.string().nonempty(),
});

export type GetTerminalPairingUpdatesParamSchema = z.infer<
	typeof getTerminalPairingUpdatesParamSchema
>;

export const getTerminalPairingUpdatesQuerySchema = z.object({
	/**
	 * The pairing secret the device was issued when it registered. It authenticates the socket:
	 * the device id in the path is a QR code the terminal shows on screen and is therefore public.
	 */
	secret: z.string().nonempty(),
});

export type GetTerminalPairingUpdatesQuerySchema = z.infer<
	typeof getTerminalPairingUpdatesQuerySchema
>;
